/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getShops = (query) => {
  var {
    itemsPerPage,
    currentPage,
    isUpdateQuery,
    totalSoldMin,
    totalSoldMax,
    sold30DaysMin,
    sold30DaysMax,
    rating,
    sortBy,
    sortOrder,
    keyword
  } = query;

  console.log("[Debug] query", query);

  const itemOffset = (currentPage - 1) * itemsPerPage;

  if (sortOrder < 0) {
    sortBy = '-' + sortBy;
    sortBy = sortBy.replace('--', '');
  }

  query = `is_update_query=${isUpdateQuery}`;

  if (keyword && keyword.trim())
    query += `&keyword=${encodeURIComponent(keyword.trim())}`;

  if (totalSoldMin && parseInt(totalSoldMin) > 0)
    query += `&total_sales>=${totalSoldMin}`;

  if (totalSoldMax && parseInt(totalSoldMax) > 0)
    query += `&total_sales<=${totalSoldMax}`;

  if (sold30DaysMin && parseInt(sold30DaysMin) > 0)
    query += `&sale_30_days>=${sold30DaysMin}`;

  if (sold30DaysMax && parseInt(sold30DaysMax) > 0)
    query += `&sale_30_days<=${sold30DaysMax}`;
  
  if (rating && parseInt(rating) > 0)
    query += `&rating_value>=${rating}`;

  query += `&limit=${itemsPerPage}`;
  query += `&skip=${itemOffset}`;
  query += `&sort=${sortBy}`;

  return API.get(`${getApiUrl()}/api/eitshop/get?${query}`);
};

// Bulk update enable_company_ids for selected shops
export const updateEnableCompanyIds = (shopIds, enableCompanyIds) => {
  const payload = {
    shop_ids: shopIds,
    enable_company_ids: enableCompanyIds
  };
  return API.post(`${getApiUrl()}/api/eitshop/set-enable-company-ids`, payload);
};

export const eitShopService = {
  getShops,
  updateEnableCompanyIds
};
